(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initCarousel(container) {
    const track = container.querySelector('.banner-carousel__track');
    const slides = container.querySelectorAll('.banner-carousel__slide');
    const prevBtn = container.querySelector('[data-prev]');
    const nextBtn = container.querySelector('[data-next]');
    const dots = container.querySelectorAll('[data-dot]');
    const autoplay = container.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 5;
    const reducedMotion = prefersReducedMotion();

    if (!track || slides.length === 0) return;

    let currentIndex = 0;
    let autoplayTimer = null;

    function goTo(index) {
      const count = slides.length;
      if (count <= 1) return;
      index = ((index % count) + count) % count;
      const prevIndex = currentIndex;
      currentIndex = index;

      slides.forEach(function (slide, i) {
        slide.classList.remove('banner-carousel__slide--active', 'banner-carousel__slide--prev');
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        if (i === prevIndex) {
          slide.classList.add('banner-carousel__slide--prev');
        }
        if (i === index) {
          slide.classList.add('banner-carousel__slide--active');
        }
      });

      dots.forEach(function (dot, i) {
        const btn = dot.tagName === 'BUTTON' ? dot : dot.querySelector('button');
        if (!btn) return;
        if (i === index) {
          btn.classList.add('banner-carousel__dot--active');
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.classList.remove('banner-carousel__dot--active');
          btn.setAttribute('aria-current', 'false');
        }
      });
    }

    function next() {
      goTo(currentIndex + 1);
    }

    function prev() {
      goTo(currentIndex - 1);
    }

    function startAutoplay() {
      if (!autoplay || reducedMotion || slides.length <= 1) return;
      stopAutoplay();
      autoplayTimer = setInterval(next, autoplaySpeed * 1000);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    dots.forEach(function (dot, i) {
      const btn = dot.tagName === 'BUTTON' ? dot : dot.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    container.addEventListener('mouseenter', stopAutoplay);
    container.addEventListener('mouseleave', function () {
      if (autoplay) startAutoplay();
    });
    container.addEventListener('focusin', stopAutoplay);
    container.addEventListener('focusout', function () {
      if (autoplay) startAutoplay();
    });

    if (reducedMotion) {
      container.dataset.reducedMotion = 'true';
    }

    startAutoplay();
  }

  function init() {
    document.querySelectorAll('[data-banner-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const carousel = e.target.querySelector('[data-banner-carousel]');
    if (carousel) initCarousel(carousel);
  });
})();
